interface RunTaskCreateSubmitCallbacks {
  onSuccess: () => void;
  onFailure?: (error: unknown) => void;
  onSettled: () => void;
}

// submitForm() only resolves once the underlying createTask mutation has
// settled (see taskFormSubmitHandler.ts). Keeping the success-only cleanup
// (reset form/clear attachments) separate from the always-run cleanup (clear
// the submitting lock) is what lets a failed mutation preserve the user's
// entered data for retry (TA-10210 QA fail).
//
// The rejection handler is passed as submitForm().then(onSuccess, onRejected)
// rather than a trailing .catch() — a trailing .catch() would also swallow
// an error thrown from inside onSuccess itself (e.g. a bug in the reset
// logic), silently masking it as if createTask had failed.
export const runTaskCreateSubmit = (
  submitForm: () => Promise<unknown>,
  { onSuccess, onFailure, onSettled }: RunTaskCreateSubmitCallbacks
) =>
  submitForm()
    .then(onSuccess, (error) => onFailure?.(error))
    .finally(onSettled);
